import { render, staticRenderFns } from "./Lgx02714035011600143876743.vue?vue&type=template&id=3f3d7d72&"
import script from "./Lgx02714035011600143876743.vue?vue&type=script&lang=js&"
export * from "./Lgx02714035011600143876743.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports